(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8990],{

/***/ 65275:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chi-tiet-van-ban/[...slug]",
      function () {
        return __webpack_require__(58249);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _common_hoc_ClientPage_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81346);
/* harmony import */ var _common_utility_asyncComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31691);




var PostDetails = (0,_common_utility_asyncComponent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
    return __webpack_require__.e(/* import() */ 7048).then(__webpack_require__.bind(__webpack_require__, 37048));
}, true);
/* harmony default export */ __webpack_exports__["default"] = ((0,_common_hoc_ClientPage_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PostDetails, {});
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,4617,3874,4614,3376,1346,9774,2888,179], function() { return __webpack_exec__(65275); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);